import { useState, useEffect } from 'react';

// Hook
export default function useKeyPress(targetKey) {
  // State for keeping track of whether key is pressed
  const [keyPressed, setKeyPressed] = useState(false);
  useEffect(() => {
    window.addEventListener('keydown', ({ key }) => {
      // console.log(key);
      if (key === targetKey) {
        setKeyPressed(true);
      }
    });
    window.addEventListener('keyup', ({ key }) => {
      if (key === targetKey) {
        setKeyPressed(false);
      }
    });
    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener('keydown');
      window.removeEventListener('keyup');
    };
  }, [targetKey]); // Empty array ensures that effect is only run on mount and unmount

  return keyPressed;
}
